(function () {
  var quiz = document.getElementById('lq-quiz');
  if (!quiz) return;

  var TOTAL_STEPS = 5;

  /* ─── Charte de tailles ─────────────────────── */
  var SIZE_CHART = {
    '32B':   { lil: 'XXSmall',   equiv: '32B / 34A' },
    '34A':   { lil: 'XXSmall',   equiv: '32B / 34A' },
    '34B':   { lil: 'XSmall',    equiv: '34B / 32C' },
    '32C':   { lil: 'XSmall',    equiv: '34B / 32C' },
    '32DD':  { lil: 'XSmall+',   equiv: '32DD' },
    '36A':   { lil: 'Small-',    equiv: '36A' },
    '34C':   { lil: 'Small',     equiv: '34C / 32D' },
    '32D':   { lil: 'Small',     equiv: '34C / 32D' },
    '34DD':  { lil: 'Small+',    equiv: '34DD / 32DDD' },
    '32DDD': { lil: 'Small+',    equiv: '34DD / 32DDD' },
    '32G':   { lil: 'Small++',   equiv: '32G' },
    '36B':   { lil: 'Medium-',   equiv: '36B' },
    '34D':   { lil: 'Medium',    equiv: '34D / 36C' },
    '36C':   { lil: 'Medium',    equiv: '34D / 36C' },
    '34DDD': { lil: 'Medium+',   equiv: '34DDD / 36DD' },
    '36DD':  { lil: 'Medium+',   equiv: '34DDD / 36DD' },
    '34G':   { lil: 'Medium++',  equiv: '34G' },
    '38B':   { lil: 'Large-',    equiv: '38B' },
    '36D':   { lil: 'Large',     equiv: '36D / 38C' },
    '38C':   { lil: 'Large',     equiv: '36D / 38C' },
    '36DDD': { lil: 'Large+',    equiv: '36DDD / 38DD' },
    '38DD':  { lil: 'Large+',    equiv: '36DDD / 38DD' },
    '40B':   { lil: 'XLarge-',   equiv: '40B' },
    '38D':   { lil: 'XLarge',    equiv: '38D' },
    '38DDD': { lil: 'XLarge+',   equiv: '38DDD' },
    '42B':   { lil: 'XXLarge-',  equiv: '42B' },
    '40D':   { lil: 'XXLarge',   equiv: '40D / 42C' },
    '42C':   { lil: 'XXLarge',   equiv: '40D / 42C' },
    '40DDD': { lil: 'XXLarge+',  equiv: '40DDD' },
    '40DD':  { lil: 'XXXLarge',  equiv: '40DD / 42D' },
    '42D':   { lil: 'XXXLarge',  equiv: '40DD / 42D' }
  };

  var state = {
    step: 1,
    taille: '',
    bonnet: '',
    style: '',
    coupe: '',
    types: [],
    priorites: [],
    email: '',
    phone: ''
  };

  /* ─── Progress ─────────────────────────────── */
  function updateProgress(n) {
    var fill  = document.getElementById('lq-progress-fill');
    var label = document.getElementById('lq-progress-label');
    if (fill)  fill.style.width = Math.round((n / TOTAL_STEPS) * 100) + '%';
    if (label) label.textContent = n + ' / ' + TOTAL_STEPS;
  }

  /* ─── Step navigation ───────────────────────── */
  function setStep(n) {
    document.querySelectorAll('.lq-step').forEach(function (el) {
      el.classList.remove('is-active');
    });

    if (n === 'results') {
      var r = document.getElementById('lq-results');
      if (r) r.classList.add('is-active');
      var prog = document.querySelector('.lq-progress');
      if (prog) prog.style.display = 'none';
      return;
    }

    state.step = n;
    var el = document.getElementById('lq-step-' + n);
    if (el) el.classList.add('is-active');
    updateProgress(n);
    window.scrollTo({ top: quiz.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
  }

  /* ─── Public nav functions ──────────────────── */
  window.lqNext = function (from) {
    if (from === 1) {
      var taille = (document.getElementById('lq-tour').value  || '').trim();
      var bonnet = (document.getElementById('lq-bonnet').value || '').trim();
      if (!taille || !bonnet) {
        if (!taille) { shake(document.getElementById('lq-tour').closest('.lq-size-group')); markSelectError(document.getElementById('lq-tour')); }
        if (!bonnet) { shake(document.getElementById('lq-bonnet').closest('.lq-size-group')); markSelectError(document.getElementById('lq-bonnet')); }
        return;
      }
      state.taille = taille;
      state.bonnet = bonnet;
      setStep(2);
    } else if (from === 2) {
      var checked = document.querySelector('input[name="lq-style"]:checked');
      if (!checked) { shake(document.querySelector('.lq-image-cards')); return; }
      state.style = checked.value;
      console.log('[Quiz] Q2 style:', state.style);
      setStep(3);
    } else if (from === 3) {
      var checkedCoupe = document.querySelector('input[name="lq-coupe"]:checked');
      if (!checkedCoupe) { shake(document.getElementById('lq-coupe-cards')); return; }
      state.coupe = checkedCoupe.value;
      console.log('[Quiz] Q3 coupe:', state.coupe);
      setStep(4);
    } else if (from === 4) {
      var priorites = selectedPills('lq-priorites-pills');
      if (!priorites.length) { shake(document.getElementById('lq-priorites-pills')); return; }
      state.priorites = priorites;
      console.log('[Quiz] Q4 priorites:', state.priorites);
      setStep(5);
    }
  };

  function markSelectError(el) {
    if (!el) return;
    el.style.borderColor = '#c0392b';
    el.addEventListener('change', function () { el.style.borderColor = ''; }, { once: true });
  }

  window.lqBack = function (from) { setStep(from - 1); };

  function shake(el) {
    if (!el) return;
    el.style.animation = 'none';
    void el.offsetWidth;
    el.style.animation = 'lq-shake 0.45s ease';
    setTimeout(function () { el.style.animation = ''; }, 500);
  }

  /* ─── Pill buttons ──────────────────────────── */
  function selectedPills(containerId) {
    return Array.from(
      document.querySelectorAll('#' + containerId + ' .lq-pill.is-selected')
    ).map(function (p) { return p.dataset.value; });
  }

  function bindPills(containerId, max) {
    var container = document.getElementById(containerId);
    if (!container) return;
    container.querySelectorAll('.lq-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var on = pill.classList.contains('is-selected');
        if (!on && max) {
          var cur = container.querySelectorAll('.lq-pill.is-selected').length;
          if (cur >= max) {
            container.querySelector('.lq-pill.is-selected').classList.remove('is-selected');
          }
        }
        pill.classList.toggle('is-selected', !on);
      });
    });
  }

  bindPills('lq-types-pills', null);
  bindPills('lq-priorites-pills', 1);

  /* ─── Image-card radio (Q2, Q3) ─────────────── */
  document.querySelectorAll('.lq-image-card').forEach(function (card) {
    card.addEventListener('click', function () {
      var container = card.closest('.lq-image-cards');
      if (container) {
        container.querySelectorAll('.lq-image-card').forEach(function (c) {
          c.classList.remove('is-selected');
        });
      }
      card.classList.add('is-selected');
      var radio = card.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
    });
  });

  /* ─── Tab switch (lead capture) ─────────────── */
  window.lqSwitchTab = function (tab) {
    document.querySelectorAll('.lq-capture__tab').forEach(function (t) {
      t.classList.toggle('is-active', t.dataset.tab === tab);
    });
    document.querySelectorAll('.lq-capture__field').forEach(function (f) {
      f.classList.remove('is-active');
    });
    var field = document.getElementById('lq-field-' + tab);
    if (field) field.classList.add('is-active');
  };

  /* ─── Submit (step 5) ───────────────────────── */
  window.lqSubmit = function () {
    var emailInput = document.getElementById('lq-email');
    var phoneInput = document.getElementById('lq-phone');
    var errorEl    = document.getElementById('lq-capture-error');
    var submitBtn  = document.getElementById('lq-submit-btn');

    var email = (emailInput ? emailInput.value : '').trim();
    var phone = (phoneInput ? phoneInput.value : '').trim();

    var emailOk = email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    var phoneOk = phone && phone.replace(/\D/g, '').length >= 8;

    if (!emailOk && !phoneOk) {
      if (errorEl) errorEl.classList.add('is-visible');
      if (emailInput) emailInput.classList.add('is-error');
      return;
    }
    if (errorEl)    errorEl.classList.remove('is-visible');
    if (emailInput) emailInput.classList.remove('is-error');
    if (phoneInput) phoneInput.classList.remove('is-error');

    state.email = emailOk ? email : '';
    state.phone = phoneOk ? phone : '';
    state.result = resolveCollection();

    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Un moment…'; }

    sendToKlaviyo(state);

    setTimeout(function () {
      setStep('results');
      loadResults(state.result);
    }, 700);
  };

  /* ─── Result collection ─────────────────────── */
  function resolveCollection() {
    var style    = state.style;
    var coupe    = state.coupe;
    var maintien = state.priorites[0] || '';

    var map = {
      'confortable|couvrant|maintien-renforce': 'ensembles-du-quotidien-copie',
      'confortable|couvrant|maintien-leger':    'ensembles-du-quotidien-maintien-optimal-tailles-petites-a-moyenne-copie',
      'confortable|demi-buste|maintien-leger':  'ensembles-du-quotidien-maintien-leger-tailles-petites-a-moyenne-copie-copie',
      'audacieuse|couvrant|maintien-leger':     'luxueux-maintien-optimal-couvrance-leger-tailles-petites-a-moyennes-copie',
      'audacieuse|couvrant|maintien-renforce':  'luxueux-maintien-optimal-couvrance-leger-tailles-petites-a-moyennes-copie',
      'audacieuse|demi-buste|maintien-leger':   'luxueux-maintien-leger-tailles-petites-a-moyennes-copie',
      'confortable|demi-buste|maintien-renforce': 'ensembles-du-quotidien-maintien-optimal-tailles-moyenne-a-forte-copie',
      'audacieuse|demi-buste|maintien-renforce':  'luxueux-maintien-optimal-tailles-moyennes-a-fortes-copie'
    };

    var key = style + '|' + coupe + '|' + maintien;
    /* eslint-disable no-console */
    console.log('[Quiz] resolveCollection key:', key, '→', map[key] || '(no match)');
    return (map[key] || 'most-confortable-collection').trim();
  }

  /* ─── Load results ──────────────────────────── */
  function loadResults(handle) {
    var loading = document.getElementById('lq-results-loading');
    var content = document.getElementById('lq-results-content');
    var grid    = document.getElementById('lq-results-grid');
    var cta     = document.getElementById('lq-results-cta');

    if (loading) {
      loading.innerHTML =
        '<div class="lq-spinner">' +
        '<svg width="38" height="38" viewBox="0 0 38 38">' +
        '<circle cx="19" cy="19" r="15" stroke="#e8e0d8" stroke-width="3" fill="none"/>' +
        '<circle cx="19" cy="19" r="15" stroke="#1a1a1a" stroke-width="3" fill="none"' +
        ' stroke-dasharray="52 68" stroke-linecap="round"/>' +
        '</svg></div>';
    }

    if (cta) {
      cta.href = '/collections/new';
      cta.textContent = 'Nouveautés →';
    }

    if (!handle) {
      if (loading) loading.style.display = 'none';
      showSizeResult();
      if (content) content.style.display = '';
      return;
    }

    fetch('/collections/' + handle + '/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = data.products || [];
        if (!products.length) {
          if (loading) loading.style.display = 'none';
          showSizeResult();
          if (content) content.style.display = '';
          return;
        }

        var cards = products.map(function (p) {
          var img    = p.images && p.images[0] ? p.images[0].src : '';
          var price  = p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : 0;
          var compare = p.variants && p.variants[0] ? parseFloat(p.variants[0].compare_at_price) : 0;
          var priceHtml = compare && compare > price
            ? '<s class="lq-card__compare">$' + compare.toFixed(2) + '</s> <span class="lq-card__price lq-card__price--sale">$' + price.toFixed(2) + '</span>'
            : '<span class="lq-card__price">$' + price.toFixed(2) + '</span>';
          return '<a href="/products/' + esc(p.handle) + '" class="lq-card">' +
            (img ? '<img class="lq-card__img" src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
            '<div class="lq-card__info"><p class="lq-card__title">' + esc(p.title) + '</p>' +
            '<p class="lq-card__prices">' + priceHtml + '</p></div>' +
            '</a>';
        });

        if (loading) loading.style.display = 'none';
        if (grid) grid.innerHTML = cards.join('');
        showSizeResult();
        if (content) content.style.display = '';
      })
      .catch(function () {
        if (loading) loading.style.display = 'none';
        showSizeResult();
        if (content) content.style.display = '';
      });
  }

  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ─── Klaviyo ───────────────────────────────── */
  function sendToKlaviyo(s) {
    var apiKey = (quiz.dataset.klaviyoKey  || '').trim();
    var listId = (quiz.dataset.klaviyoList || '').trim();

    var profileProps = {};
    if (s.taille)           profileProps['Quiz_Taille']    = s.taille + s.bonnet;
    if (s.style)            profileProps['Quiz_Style']     = s.style;
    if (s.coupe)            profileProps['Quiz_Coupe']     = s.coupe;
    if (s.types.length)     profileProps['Quiz_Types']     = s.types.join(', ');
    if (s.priorites.length) profileProps['Quiz_Priorites'] = s.priorites.join(', ');
    if (s.result)           profileProps['Quiz_Resultat']  = s.result;

    var identify = Object.assign({ '$email': s.email || undefined, '$phone_number': s.phone || undefined }, profileProps);
    Object.keys(identify).forEach(function (k) { if (!identify[k]) delete identify[k]; });

    /* Method 1: Klaviyo JS SDK (_learnq) — works when Klaviyo app is installed */
    if (window._learnq) {
      window._learnq.push(['identify', identify]);
      window._learnq.push(['track', 'Quiz Parure Complété', {
        taille:    s.taille + s.bonnet,
        style:     s.style,
        types:     s.types,
        priorites: s.priorites,
        resultat:  s.result
      }]);
    }

    /* Method 2: Klaviyo Client API (public key only, CORS-safe) */
    if (!apiKey) return;
    var base    = 'https://a.klaviyo.com/client/';
    var qp      = '?company_id=' + encodeURIComponent(apiKey);
    var headers = { 'Content-Type': 'application/vnd.api+json', 'revision': '2023-02-22' };

    /* Create / update profile */
    var profileAttrs = Object.assign({}, profileProps);
    if (s.email) profileAttrs.email        = s.email;
    if (s.phone) profileAttrs.phone_number = s.phone;

    fetch(base + 'profiles/' + qp, {
      method: 'POST', headers: headers,
      body: JSON.stringify({ data: { type: 'profile', attributes: profileAttrs } })
    }).catch(function () {});

    /* Subscribe to list */
    if (listId) {
      var subAttrs = { list_id: listId, custom_source: 'Quiz Parure Lil' };
      if (s.email) subAttrs.email        = s.email;
      if (s.phone) subAttrs.phone_number = s.phone;
      fetch(base + 'subscriptions/' + qp, {
        method: 'POST', headers: headers,
        body: JSON.stringify({ data: { type: 'subscription', attributes: subAttrs } })
      }).catch(function () {});
    }

    /* Track event */
    var custProfile = {};
    if (s.email) custProfile.email        = s.email;
    if (s.phone) custProfile.phone_number = s.phone;
    fetch(base + 'events/' + qp, {
      method: 'POST', headers: headers,
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            metric: { data: { type: 'metric', attributes: { name: 'Quiz Parure Complété' } } },
            profile: { data: { type: 'profile', attributes: custProfile } },
            properties: {
              taille:    s.taille + s.bonnet,
              style:     s.style,
              types:     s.types,
              priorites: s.priorites,
              resultat:  s.result
            }
          }
        }
      })
    }).catch(function () {});
  }

  /* ─── Restart ───────────────────────────────── */
  window.lqRestart = function () {
    state = { step: 1, taille: '', bonnet: '', style: '', coupe: '', types: [], priorites: [], email: '', phone: '' };

    var tour   = document.getElementById('lq-tour');
    var bonnet = document.getElementById('lq-bonnet');
    var email  = document.getElementById('lq-email');
    var phone  = document.getElementById('lq-phone');
    var btn    = document.getElementById('lq-submit-btn');

    if (tour)   tour.value   = '';
    if (bonnet) bonnet.value = '';
    if (email)  email.value  = '';
    if (phone)  phone.value  = '';
    if (btn)  { btn.disabled = false; btn.textContent = 'Découvrir mes recommandations'; }

    document.querySelectorAll('.lq-image-card').forEach(function (c) { c.classList.remove('is-selected'); });
    document.querySelectorAll('input[name="lq-style"]').forEach(function (r) { r.checked = false; });
    document.querySelectorAll('input[name="lq-coupe"]').forEach(function (r) { r.checked = false; });
    document.querySelectorAll('.lq-pill').forEach(function (p) { p.classList.remove('is-selected'); });

    var loading  = document.getElementById('lq-results-loading');
    var content  = document.getElementById('lq-results-content');
    var grid     = document.getElementById('lq-results-grid');
    var sizeCard = document.getElementById('lq-size-result');
    if (loading)  { loading.innerHTML = ''; loading.style.display = ''; }
    if (content)  content.style.display = 'none';
    if (grid)     grid.innerHTML = '';
    if (sizeCard) sizeCard.style.display = 'none';

    var prog = document.querySelector('.lq-progress');
    if (prog) prog.style.display = '';

    setStep(1);
  };

  /* ─── Size result (shown on results page) ───── */
  function showSizeResult() {
    var key   = state.taille + state.bonnet;
    var match = SIZE_CHART[key];
    var card  = document.getElementById('lq-size-result');
    if (!card) return;
    if (!match) { card.style.display = 'none'; return; }
    var lilEl   = document.getElementById('lq-size-lil');
    var equivEl = document.getElementById('lq-size-equiv');
    if (lilEl)   lilEl.textContent   = match.lil;
    if (equivEl) equivEl.textContent = match.equiv;
    card.style.display = '';
  }

  /* ─── Init ──────────────────────────────────── */
  updateProgress(1);
})();
